import * as utilities from "../src/utilities";
import * as stash from "../src/stash";
import * as digitalDataFormatters from "../src/digitalDataFormatters";
import * as appData from "../src/appData";
import * as productString from "../src/productString";

/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */

var mapMethods = {

	'setErrorMessage': function ( ) {
		s.events = utilities.apl( 'event49' );
		s.linkTrackEvents = utilities.apl( 'event49', s.linkTrackEvents );

	},

	'setSearchTypeAheadImpression': function ( data ) {
		var result = "",
			first = "";

		data = ( typeof ( data ) !== 'undefined' ? data : '' );

		if ( Array.isArray( data ) && data.length ) {

			// grab first element in the array to use as prefix for any element in the array that starts with ' in '
			first = data[ 0 ];

			result = data.map( function ( term ) {

				return ( term.toString().indexOf( " in " ) !== 0 ? term : first + "~" + term );

			} ).join( "|" );

		}

		return result;

	},

	'setEvar21ForBrowseAndSearch': function ( sourceobj,  v21event = 'event14' ) {

		let result = "";

		if ( sourceobj.displayAttributes && ( sourceobj.displayAttributes.viewType || sourceobj.displayAttributes.sortBy || sourceobj.displayAttributes.productsAvailability ) ) {

			result += sourceobj.displayAttributes.viewType ? sourceobj.displayAttributes.viewType : '';
			result += "|";
			result += sourceobj.displayAttributes.sortBy ? sourceobj.displayAttributes.sortBy : '';
			result += "|";
			result += sourceobj.displayAttributes.productsAvailability ? sourceobj.displayAttributes.productsAvailability : '';

		}

		if ( v21event ) {

			s.events = utilities.apl( v21event );

		}

		return ( result ? result : "no ddo" );

	},

	'setRedirect': function ( ddo ) {

		var semanticBits,
			fifthBit,
			num;

		var stashedData = stash.getPersistedDataObject();

		var searchTerm = ( function () {

			var searchTerm = "",
				searchRedirect = s.getQueryParam( 'searchRedirect' );

			if ( stashedData.searchTerm ) {
				searchTerm = stashedData.searchTerm;
			}
			else if ( ddo.page.onsiteSearchInfo.searchTerm ) {

				searchTerm = ddo.page.onsiteSearchInfo.searchTerm;

			} else if ( searchRedirect !== "") {

				searchTerm = searchRedirect;
			}
			// looks weird but found that we need to double decode some search term values, like those coming from type ahead
			return decodeURI( decodeURI( searchTerm ) );

		}() );

		if ( searchTerm ) {

			if ( ddo.page.onsiteSearchInfo.semanticSearchTokens || s.getQueryParam( 'searchRedirect' ) !== "" && s.getQueryParam( 'semanticToken' ) !== "" ) {

				s.events = utilities.apl( "event15", s.events );

				s.prop4 = searchTerm;

				s.eVar5 = s.prop4;
				s.eVar12 = "text";

				s.eVar63 = "category redirect";

				semanticBits = s.getQueryParam( 'semanticToken' ).split( " ", 1 );

				if ( semanticBits[ 0 ].length === 5 ) {

					fifthBit = semanticBits.toString().slice( -1 );
					num = parseInt( fifthBit );

					switch ( num ) {
						case 0:
							s.eVar63 = "non redirect";
							break;
						case 1:
							s.eVar12 = "redirect";
							s.eVar63 = "search config redirect";
							break;
						case 2:
							s.eVar12 = "redirect";

							break;
						case 3:
							s.eVar12 = "redirect";
							s.eVar63 = "rental redirect";
							break;
						default:
							break;
					}
				}

			}
		}
	},


	'setInitialLoadSearchNucleus': function ( ddo ) {

			let searchTerm = ( ddo.page.onsiteSearchInfo.searchTerm ? ddo.page.onsiteSearchInfo.searchTerm : '' );

			const stashedData = stash.getPersistedDataObject();

			const searchMedium = ( function () {

				let searchMedium = "";

				if ( stashedData.searchMedium ) {
					searchMedium = stashedData.searchMedium;
				}
				else if ( ddo.page.onsiteSearchInfo.searchMedium ) {
					searchMedium = ddo.page.onsiteSearchInfo.searchMedium;
				}

				return searchMedium;

			}() );

			const sl_token = s.getQueryParam( 'sl_token' );

			const refinements = ( function ( pageobj ) {

				let result = "";

				if ( Array.isArray( pageobj.filter ) && pageobj.filter.length > 0 ) {
					let arrLength = pageobj.filter.length;

					for ( let index = 0; index < arrLength; index += 1 ) {
						result += pageobj.filter[ index ].position + "," + pageobj.filter[ index ].type + ":" + pageobj.filter[ index ].value;

						if ( pageobj.filter[ index ].selectionMethod ) {
							result += "," + pageobj.filter[ index ].selectionMethod;
						}

						if ( index < arrLength - 1 ) {
							result += "|";
						}
					}

					s.events = utilities.apl( "event14" );
				}

				return result;

			}( ddo.page ) );

			searchTerm = ( function () {

				let searchTerm = "";

				if ( stashedData.searchTerm ) {
					searchTerm = stashedData.searchTerm;
				}
				else if ( ddo.page.onsiteSearchInfo.searchTerm ) {
					searchTerm = ddo.page.onsiteSearchInfo.searchTerm;
				}

				return searchTerm;

			}() );

            s.events = utilities.apl( "event15" );

			s.prop4 = searchTerm;

			s.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );

			s.prop16 = ( refinements && !stashedData.refinements ?  'D=v29' : "" );

			s.prop21 = utilities.readCookieKeyValue( "s_sess", "s_pv_pName" );

			s.eVar5 = searchTerm;
			s.eVar8 = ddo.page.pageInfo.pageType;

			s.eVar12 = ( function ( ddo ) {
				let searchType = "";

				if ( ddo.page.onsiteSearchInfo.relatedSearch && s.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related Search";
				}
				if ( ddo.page.onsiteSearchInfo.relatedCategory && s.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related category";
				}
				if ( s.getQueryParam( 'searchRedirect' ) !== "" ) {
					searchType = "redirect";
				}
				/* Internal Search Terms (SearchCenter) - defined on standard search */
				if ( searchTerm ) {
					if ( ddo.page.onsiteSearchInfo.correctedTerm && ddo.page.onsiteSearchInfo.resultsType === "spell correction" ) {
						searchType = ddo.page.onsiteSearchInfo.resultsType;
					}
					else if ( ddo.page.onsiteSearchInfo.numberOfResults === '0' ) {
						searchType = "null";
					}
					else {
						searchType = "text";
					}
				}

				if ( searchMedium ) {
					searchType = searchMedium;
				}

				if ( sl_token ) {
					searchType = "image search";
				}

				if ( ddo.page.onsiteSearchInfo.numberOfResults === '0' ) {
					searchType = searchMedium + "|" + ddo.page.onsiteSearchInfo.resultsType;
				}

				return searchType;
			}( ddo ) );

			s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

			s.eVar29 = refinements;

			s.eVar63 = ( function () {

				let result = "";
				let searchIntent = ( typeof ( ddo.page.onsiteSearchInfo.searchIntent ) === 'string' ? ddo.page.onsiteSearchInfo.searchIntent.toLowerCase() : '' );

				if ( stashedData.searchTypeAheadType ) {
					result = stashedData.searchTypeAheadType;
				}
				else if ( stashedData.searchMedium ) {
					result = stashedData.searchMedium;
				}
				else if ( sl_token ) {
					result = "image search";
				}
				else {
					result = ddo.page.onsiteSearchInfo.resultsCategory;
				}

				result = ( searchIntent === "rental intent" ? searchIntent : result );

				return result;

			}() );

	},
	'setInitialLoadBrowseNucleus': function ( ddo ) {

		const stashedData = stash.getPersistedDataObject();

		// merge stashData with onsiteSearchInfo, giving stash the priority
		let searchInfo = { ...ddo.page.onsiteSearchInfo, ...stashedData };

		if ( searchInfo.searchTerm ) {

			s.events = utilities.apl( "event15", s.events );

			s.prop4 = searchInfo.searchTerm;

			s.eVar5 = searchInfo.searchTerm;

			s.eVar12 = ( function ( ddo ) {

				let searchType = "";
				let sl_token = s.getQueryParam( 'sl_token' );

				if ( ddo.page.onsiteSearchInfo.relatedSearch && s.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related Search";
				}
				if ( ddo.page.onsiteSearchInfo.relatedCategory && s.getQueryParam( 'relatedSearch' ) ) {
					searchType = "related category";
				}
				if ( s.getQueryParam( 'searchRedirect' ) !== "" ) {
					searchType = "redirect";
				}

				if ( sl_token ) {
					searchType = "image search";
				}

				if ( searchInfo.correctedTerm && searchInfo.resultsType === "spell correction" ) {
					searchType = searchInfo.resultsType;
				}
				else if ( searchInfo.numberOfResults === '0' ) {
					searchType = "null";
				}
				else {
					searchType = "text";
				}

				if ( searchInfo.searchMedium ) {
					searchType = searchInfo.searchMedium;
				}

				return searchType;
			}( ddo ) );

			s.eVar63 = ( function () {

				let result = "";

				if ( searchInfo.searchTypeAheadType ) {
					result = searchInfo.searchTypeAheadType;
				}
				else if ( searchInfo.searchMedium ) {
					result = searchInfo.searchMedium;
				}

				return result;

			}() );

		} else {

			s.eVar5 = "non-search";

		}

		s.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );

		s.prop21 = utilities.readCookieKeyValue( "s_sess", "s_pv_pName" );

		s.prop16 = 'D=v29';

		s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

		s.eVar29 = ( function ( pageobj ) {
			let result = "";

			if ( Array.isArray( pageobj.filter ) && pageobj.filter.length > 0  ) {
				let arrLength = pageobj.filter.length;

				for ( var index = 0; index < arrLength; index += 1 ) {
					result += pageobj.filter[ index ].position + "," + pageobj.filter[ index ].type + ":" + pageobj.filter[ index ].value;

					if ( pageobj.filter[ index ].selectionMethod ) {
						result += "," + pageobj.filter[ index ].selectionMethod;
					}

					if ( index < arrLength - 1 ) {
						result += "|";
					}
				}
			}

			return result;
		}( ddo.page ) );

		//no search results found event
		if ( ddo.page.onsiteSearchInfo.numberOfResults === "0" && ddo.page.pageInfo.pageName === "no search results" ) {
			s.events = utilities.apl( "event32" );
		}

	},

	'setFilterBy': function ( ddo, eventIndex ) {
		let index = 0;

		s.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		s.events = utilities.apl( 'event37' );

		s.prop4 = ddo.page.onsiteSearchInfo.searchTerm;

		s.prop8 = ddo.page.onsiteSearchInfo.numberOfResults;

		s.prop16 = ( function ( ddo, eventIndex ) {
			var result = "";

			if ( ddo.event[ eventIndex ].filter && ddo.event[ eventIndex ].filter.length > 0 ) {
				var lastIndex = ddo.event[ eventIndex ].filter.length - 1;

				result += ddo.event[ eventIndex ].filter[ lastIndex ].position + "," + ddo.event[ eventIndex ].filter[ lastIndex ].type + ":" + ddo.event[ eventIndex ].filter[ lastIndex ].value;

				if ( ddo.event[ eventIndex ].filter[ lastIndex ].selectionMethod ) {
					result += "," + ddo.event[ eventIndex ].filter[ lastIndex ].selectionMethod;
				}

			}

			return result;
		}( ddo, eventIndex ) );

		s.prop21 = utilities.readCookieKeyValue( "s_sess", "s_pv_pName" );
		s.prop30 = ddo.page.pageInfo.pageType;
		s.prop36 = ddo.page.onsiteSearchInfo.searchTerm;

		s.eVar5 = ddo.page.onsiteSearchInfo.searchTerm;

		s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );

		s.eVar29 = ( function ( ddo, eventIndex ) {
			var result = "";

			if ( ddo.event[ eventIndex ].filter && ddo.event[ eventIndex ].filter.length > 0 ) {
				var arrLength = ddo.event[ eventIndex ].filter.length;

				for ( index; index < arrLength; index += 1 ) {
					result += ddo.event[ eventIndex ].filter[ index ].position + "," + ddo.event[ eventIndex ].filter[ index ].type + ":" + ddo.event[ eventIndex ].filter[ index ].value;

					if ( index < arrLength - 1 ) {
						result += "|";
					}
				}

			}

			return result;
		}( ddo, eventIndex ) );

		s.eVar63 = ddo.page.onsiteSearchInfo.resultsCategory;

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			s.events = utilities.apl( "event119" );

			s.products = productString.productImpression( ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

		}

        s.linkTrackEvents = utilities.apl( 'event37,event119', s.linkTrackEvents );
        s.linkTrackVars = utilities.apl( 'prop4,prop8,prop16,prop21,prop30,eVar5,eVar21,products', s.linkTrackVars );
	},

	'setPagination': function ( ddo, eventIndex ) {

		s.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName;

		s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			s.events = utilities.apl( "event119" );

			s.products = productString.productImpression( ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

		}

		if ( ddo.event[ eventIndex ].category.primaryCategory === "browse" || ddo.event[ eventIndex ].category.primaryCategory === "search" ) {

			s.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );
			s.prop16 = 'D=v29';

			s.eVar29 = ( function ( ddo, eventIndex ) {
				let result = "";

				if ( ddo.event[ eventIndex ].filter && ddo.event[ eventIndex ].filter.length > 0 ) {
					var arrLength = ddo.event[ eventIndex ].filter.length;

					for ( var index = 0; index < arrLength; index += 1 ) {
						result += ddo.event[ eventIndex ].filter[ index ].position + "," + ddo.event[ eventIndex ].filter[ index ].type + ":" + ddo.event[ eventIndex ].filter[ index ].value;

						if ( ddo.event[ eventIndex ].filter[ index ].selectionMethod ) {
							result += "," + ddo.event[ eventIndex ].filter[ index ].selectionMethod;
						}

						if ( index < arrLength - 1 ) {
							result += "|";
						}
					}
				}

				return result;
			}( ddo, eventIndex ) );
		}
	},

	'setSortBy': function ( ddo, eventIndex ) {

		s.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;

		s.events = utilities.apl( 'event37' );

		s.prop30 = ddo.page.pageInfo.pageType;

		s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );

		if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
			s.events = utilities.apl( "event119" );

			s.products = productString.productImpression( ddo.content.product, {
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
			} );

		}

        s.linkTrackEvents = utilities.apl( 'event37,event119', s.linkTrackEvents );
        s.linkTrackVars = utilities.apl( 'prop30,eVar21,products', s.linkTrackVars );

	},

	'setCommonTypeBy': function ( ddo, eventIndex ) {

		s.pageName = ddo.page.pageInfo.pageName + ">" + ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
		s.events = utilities.apl( 'event37' );

		s.products = productString.productImpression( ddo.content.product, {
			"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ eventIndex ] )
		} );

        s.linkTrackEvents = utilities.apl( 'event37', s.linkTrackEvents );
		s.linkTrackVars = utilities.apl( 'eVar21,products', s.linkTrackVars );

	},

	'setCartAdd': function ( ddo, eventIndex ) {

		var stashRecAddLoc = stash.getEventData( "recCartAddLoc" ),
			//Giving Recommendation ATC Location priority when setting ATC Location in the product string
			stashATCLoc = ( stashRecAddLoc ? stashRecAddLoc : stash.getEventData( "cart add location" ) ),
			stashRecCartAdd = stash.getEventData( "recommendationCartAdd" ),
			stashCheckFulfillmentAvailability = stash.getEventData( "check fulfillment availability" ),
			stashEta = stash.getEventData( "checkFulfillmentAvailabilityEta" ),
			stashBadgeClickThrough = stash.getEventData( "atcBadgeClickThrough" ),
			stashPodClick = mapMethods.getPodClick();

		s.channel = 'cart add';
        s.events = utilities.apl( 'scAdd,event2,event4' );

		let productStringCartAddOptions = {
			"atcloc": stashATCLoc,
			"recobj": stashRecCartAdd,
			"checkfulfillobj": stashCheckFulfillmentAvailability,
			"badgeClickThrough": stashBadgeClickThrough,
			"etaobj": stashEta,
			"podclick": stashPodClick
		};

		s.products = productString.cartAdd( ddo.event[ eventIndex ].item, ddo, productStringCartAddOptions );

		// clear stash values after using them in productString.cartAdd()
		stash.deleteEventData( "cart add location" );
		stash.deleteEventData( "recommendationCartAdd" );
		stash.deleteEventData( "recCartAddLoc" );
		stash.deleteEventData( "check fulfillment availability" );
		stash.deleteEventData( "atcBadgeClickThrough" );

		stash.deletePersistedData( "podClick" );
		stash.deleteEventData( "atcPodClick" );

		s.prop15 = ddo.page.pageInfo.pageName;
		s.prop17 = ddo.page.pageInfo.pageType;
		s.prop30 = 'cart add overlay';

		s.eVar8 = 'cart add overlay';
        s.eVar37 = ( ddo.event[ eventIndex ].cart && ddo.event[ eventIndex ].cart.cartID ? ddo.event[ eventIndex ].cart.cartID : '' );
		s.eVar63 = appData.getFromCache( "pageLoadeVar63" );
		s.eVar96 = s.prop15 ? s.prop15 : '';
		s.eVar97 = ddo.page.pageInfo.pageType;

		stash.deleteEventData( "selectedCategory" );
		stash.deleteEventData( "selectedColor" );

	},

	'setCartRemove': function ( ddo, eventIndex ) {

		s.events = utilities.apl( "scRemove,event17,event18" );

		s.events = utilities.apl( "event175" );

		s.products = productString.cartRemove( ddo.event[ eventIndex ].item, {
			"v95": s.eVar95
		} );

        s.linkTrackEvents = utilities.apl( "scRemove,event17,event18,event175", s.linkTrackEvents );
        s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
	},

	'setProductView': function ( ddo ) {

		var stashedData = stash.getPersistedDataObject();
		var keyword = s.Util.getQueryParam( 'keyword' );

		var searchTerm = ( function () {

			var searchTerm = "";

			if ( stashedData.searchTerm ) {
				searchTerm = stashedData.searchTerm;
			}
			else if ( keyword ) {
				searchTerm = decodeURIComponent( keyword );
			}
			else if ( ddo.product[ 0 ].productInfo.sku ) {
				searchTerm = ddo.product[ 0 ].productInfo.sku;
			}

			return searchTerm;

		}() );

		var isRedirect = ( function ( sd, kw, rsd ) {
			let sm = ( typeof ( ddo.page.onsiteSearchInfo.searchMedium ) === 'string' ? ddo.page.onsiteSearchInfo.searchMedium.toLowerCase() : "" );

			if ( !utilities.objHasValue( rsd ) && ( ( kw && document.referrer.indexOf( "/webapp/catalog/servlet/Search" ) === -1 ) || sd.searchTerm ||  sm === 'redirect' )) {

				return true;
			}

			return false;

		}( stashedData, keyword ) );

		if ( isRedirect ) {

			s.prop4 = searchTerm;

			s.prop8 = "1";

			s.eVar5 = searchTerm;

			s.eVar12 = ( function () {

				if ( ddo.page.onsiteSearchInfo.searchMedium ) {

					return ddo.page.onsiteSearchInfo.searchMedium;

				}

				if ( stashedData.searchMedium ) {

					return stashedData.searchMedium;

				}

				return "text";

			}() );

			s.eVar63 = ( stashedData.searchTypeAheadType ) ? stashedData.searchTypeAheadType : "search all";

		}

		s.products = productString.productView( ddo.product );

        s.events = utilities.apl( 'prodView,event16', ( s.events ? s.events : "" ) );

		s.eVar8 = ddo.page.pageInfo.pageType;

		stash.deletePersistedData( "podClick" );
		stash.deletePersistedData( "selectedCategory" );
		stash.deletePersistedData( "selectedColor" );
		stash.deletePersistedData( "viewportImpressionAudit" );

	},

	'setEvar26': function ( ddo ) {

		var result = ( ddo.user.profile.authenticationStatus ? ddo.user.profile.authenticationStatus : '' );

		return result;
	},

	'getPodClick': function () {

		var stashDataObj = stash.getPersistedDataWithKey( "podClick" );

		if ( !stashDataObj ) {
			stashDataObj = stash.getEventData( "atcPodClick" );
		}

		return stashDataObj;
	},
	'getImpressionPageNumber': function ( evtObj, pageObj ) {
		let pageNumber = "";

		if ( typeof evtObj !== 'undefined' && evtObj.displayAttributes && evtObj.displayAttributes.pageNumber ) {
			pageNumber = evtObj.displayAttributes.pageNumber;
		} else if ( typeof pageObj !== 'undefined' && pageObj.displayAttributes && pageObj.displayAttributes.pageNumber ) {
			pageNumber = pageObj.displayAttributes.pageNumber;
		}

		return pageNumber;

	},

};

var nodes = {
	'universal': {
		'forcePageView': false,
		'reportingType': 't',
		'setMetrics': function ( ddo ) {

			window._T.deployments.core.versions.daMap = CODE_VERSION;

			s.pageURL = document.URL;

			s.pageName = ddo.page.pageInfo.pageName;

			s.prop5 = utilities.readCookieKeyValue( "s_sess", "s_pv_pType" );
			s.prop13 = s.getNewRepeat( 365 );
			s.prop24 = 'am=' + s.version + '|build=' + BUILD_TARGET + '|version=' + CODE_VERSION + '|ts=' + '2024-09-25T20:18:13.000Z';

			s.prop34 = utilities.getWindowOrientation();
			s.prop38 = ( typeof ( Visitor ) !== "undefined" ? "VisitorAPI Present" : "VisitorAPI Missing" );

			s.prop46 = "D=g";

			s.prop56 = ( function () {

				const beaconExecutionType = appData.getFromCache( "beaconExecutionType" );
				return ( beaconExecutionType ? beaconExecutionType : 'standard' );

			}() );

			stash.deletePersistedData( "globalMyAccountSettings" );

			s.eVar17 = "D=pageName";

			s.eVar26 = ( function ( ddo ) {
				let result = mapMethods.setEvar26( ddo );

				// implements use cases "Sign in alongside other tracking" and "Registration alongside other tracking "
				if ( ddo.user.profile.action === 'sign in' || ddo.user.profile.action === 'register' ) {
					s.events = ( ddo.user.profile.action === 'register' ? utilities.apl( "event1,event25" ) : utilities.apl( "event25" ) );
					result = 'authenticated';
				}

				return result;
			}( ddo ) );

			/*Quatum Metric User and Session Ids*/
			s.eVar60 = ( function () {
				if ( window.QuantumMetricAPI ) {
					let getUser = (  typeof ( window.QuantumMetricAPI.getUserID ) === 'function' ? window.QuantumMetricAPI.getUserID() : undefined ),
						getSession = ( typeof ( window.QuantumMetricAPI.getSessionID ) === 'function' ? window.QuantumMetricAPI.getSessionID() : undefined );
					return ( typeof ( getUser ) === 'string' ? getUser : 'na' ) + '|' + ( typeof ( getSession ) === 'string' ? getSession : 'na' );
				}
			}() )

			/* Set eVar61 with the PcId */
			s.eVar61 = ( window.mboxFactoryDefault && typeof window.mboxFactoryDefault.getPCId === "function" ? window.mboxFactoryDefault.getPCId().getId() : '' );

			/* Time Parting */
			s.eVar69 = ( function () {
				let value = s.getDaysSinceLastVisit();
				let result = ( value === "New Visitor" ? "first visit" : value );
				return result;
			}() );

            s.eVar37 = digitalDataFormatters.formatCartID( ddo, ddo.cart.cartID );

			/* eVar captures visitID to aid filter of visitors identified as bots (supports perimeterx integration) */
			s.eVar99 = "D=mid";

			mapMethods.setRedirect( ddo );

			// Product Impression Tracking
			if ( !appData.getFromCache( "suppressProductImpression" ) && ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {

				// the appData setter will push this value to the private array
				appData.addInternalEvents( {
					"category": {
						"primaryCategory": "content display"
					},
					"eventInfo": {
						"eventName": "product impression"
					}
				} );

				appData.addUpdateCache( "suppressProductImpression", true ); // We only want to send this info once per page load
			}

		}

	},
	't': {
		'setMetrics': function ( ddo, eventIndex ) {
			s.channel = ddo.page.category.primaryCategory;

			s.campaign = s.Util.getQueryParam( "utm_campaign" );
			s.eVar56 = s.Util.getQueryParam( "utm_content" );
			s.eVar57 = s.Util.getQueryParam( "utm_medium" );
			s.eVar58 = s.Util.getQueryParam( "utm_source" );
			s.eVar76 = s.Util.getQueryParam( "utm_term" );

			s.prop30 = ddo.page.pageInfo.pageType;

			// capture previous page name on all page level tracking
			s.prop52 = utilities.readCookieKeyValue( "s_sess", "s_pv_pName" );

			s.eVar8 = ( s.prop30 ? s.prop30 : '' );

			/*Capture of Google id_GCLID*/
            s.eVar107 = s.Util.getQueryParam( "gclid", document.URL );

			/* if orig_ref param exists populate s.referrer */
			var oref = s.Util.getQueryParam( "orig_ref", document.URL );
			var utmref = s.Util.getQueryParam( "utm_referrer", document.URL );

			// orig ref takes precedent
			oref = ( oref ? oref : utmref ? utmref : '' );

			if ( oref ) {
				if ( oref.indexOf( 'http%' ) === 0 || oref.indexOf( 'https%' ) === 0 ) {
					s.referrer = unescape( oref );
				}
				else {
					s.referrer = oref;
				}
			}
			/**
			 * Page level enhanced error tracking
			 *   Iterates over ddo.page.error array to find unreported errors.
			 *   if any found, add to s.list2 and mark as reported
			 *   ~ sets isReported = true for newly reported errors so they will not be processed again.
			 */
			s.list2 = ( function ( ddo ) { //TODO: when we remove the legacy error requirement for OPC, we can combine the s.t() and s.tl() setting of s.list2 into a common method

				var list2 = "";

				if ( Array.isArray( ddo.page.error ) ) {

					var errors = ddo.page.error,
						result = [],
						_left = function ( str, count ) { // main purpose of this method is the safe checking
							str = typeof str !== 'undefined' ? str : '';
							count = typeof count !== 'undefined' ? count : 2;

							return str.substr( 0, count );
						};

					errors.forEach( function ( error, index ) {
						if ( !error.isReported ) {
							error.isReported = true;
							digitalData.page.error[ index ].isReported = true;
							result.push( _left( error.type ) + ":" + _left( error.displayType ) + ":" + ( error.pageSection ? error.pageSection : '' ) + ":" + ( error.message ? error.message : '' ) + ":" + ( error.code ? error.code : '' ) );
						}
					} );

					list2 = result.join( "|" );
				}

				if ( list2 ) {
					s.events = utilities.apl( 'event49' );
				}

				return list2;

			}( ddo, eventIndex ) );

			/* Save / Retrieve cart */
			if ( ddo.cart.action ) {
				var _cartAction = ddo.cart.action;
				if ( _cartAction === 'save' ) {
					s.events = utilities.apl( "event158" );
				}
				else if ( _cartAction === 'retrieve cart' ) {
					s.events = utilities.apl( "event162" );
				}
			}

			var internalSearchStash = stash.getPersistedDataObject();

			if ( internalSearchStash.searchTerm ) {

				s.events = utilities.apl( "event15" );

				s.prop4 = internalSearchStash.searchTerm;
				s.prop8 = "1";

				s.eVar5 = internalSearchStash.searchTerm;
				s.eVar12 = ( internalSearchStash.searchMedium ) ? internalSearchStash.searchMedium : "text";
				s.eVar63 = ( internalSearchStash.searchTypeAheadType ) ? internalSearchStash.searchTypeAheadType : "search all";

			}

		}
	},
	'tl': {
		'setMetrics': function () {

            s.linkTrackVars = utilities.apl( "pageName,events,prop5,prop13,prop24,prop34,prop37,prop38,prop46,prop55,prop56,prop57,eVar17,eVar26,eVar37,eVar61,eVar69,eVar94,eVar99", s.linkTrackVars );
		}
	},
	'final': {
		'setMetrics': function () {
		}
	},

	'blinds_customizer_page': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			s.products = productString.skuOnly( ddo.product );

			s.events = utilities.apl( 'event155' );
		}
	},
	'blinds_samples_cart': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( 'event163' );

			s.products = productString.cartView( ddo.cart.item );
		}
	},
	'blinds_shipping_page': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( 'event165' );

			s.products = productString.cartView( ddo.cart.item );
		}
	},
	'blinds_payment_and_billing_page': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( 'event166' );

			s.products = productString.cartView( ddo.cart.item );
		}
	},
	'blinds_offline_order_confirmation': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			s.eVar55 = ( ddo.referral && ddo.referral.type ? ddo.referral.type : '' );
		}
	},
	'blinds_paypal_shipping_page': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( 'event174' );

			s.products = productString.cartView( ddo.cart.item );
		}
	},
	'button_submission*item_config_update': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "item config update",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'scAdd,event2,event4,event156,event157' );
			s.products = productString.cartAdd( ddo.event[ eventIndex ].item, ddo );

            s.linkTrackEvents = utilities.apl( 'scAdd,event2,event4,event156,event157', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
		}
	},
	'button_submission*blinds_paypal_cart': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "blinds paypal cart",
		'setMetrics': function () {
			s.events = utilities.apl( 'scCheckout,event167' );
			s.linkTrackEvents = utilities.apl( 'scCheckout,event167', s.linkTrackEvents );
		}
	},
	'button_submission*blinds_paypal_shipping': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "blinds paypal shipping",
		'setMetrics': function () {
			s.events = utilities.apl( 'event168' );
			s.linkTrackEvents = utilities.apl( 'event168', s.linkTrackEvents );
		}
	},
	'button_submission*design_save': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design save",
		'setMetrics': function () {
			s.events = utilities.apl( 'event210' );
			s.linkTrackEvents = utilities.apl( 'event210', s.linkTrackEvents );
		}
	},
	'button_submission*design_delete': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design delete",
		'setMetrics': function () {
			s.events = utilities.apl( 'event211' );
			s.linkTrackEvents = utilities.apl( 'event211', s.linkTrackEvents );
		}
	},
	'button_submission*design_duplicate': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design duplicate",
		'setMetrics': function () {
			s.events = utilities.apl( 'event212' );
			s.linkTrackEvents = utilities.apl( 'event212', s.linkTrackEvents );
		}
	},
	'button_submission*design_shop_products': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design shop products",
		'setMetrics': function () {
			s.events = utilities.apl( 'event213' );
			s.linkTrackEvents = utilities.apl( 'event213', s.linkTrackEvents );
		}
	},
	'button_submission*design_add_product': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design add product",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'event214' );

			s.products = productString.skuOnly( ddo.event[ eventIndex ].item );

			s.linkTrackEvents = utilities.apl( 'event214', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
		}
	},
	'button_submission*design_remove_product': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design remove product",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'event215' );

			s.products = productString.skuOnly( ddo.event[ eventIndex ].item );

			s.linkTrackEvents = utilities.apl( 'event215', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
		}
	},
	'button_submission*design_swap_products': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design swap products",
		'setMetrics': function () {
			s.events = utilities.apl( 'event216' );
			s.linkTrackEvents = utilities.apl( 'event216', s.linkTrackEvents );
		}
	},
	'button_submission*design_item_config_update': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design item config update",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'event217' );

			s.products = productString.skuOnly( ddo.event[ eventIndex ].item );

			s.linkTrackEvents = utilities.apl( 'event217', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
		}
	},
	'button_submission*design_copy_style': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "design copy style",
		'setMetrics': function () {
			s.events = utilities.apl( 'event218' );
			s.linkTrackEvents = utilities.apl( 'event218', s.linkTrackEvents );
		}
	},
	'button_submission*video_start': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "video start",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'event13' );
			s.eVar168 = ( ddo.event && ddo.event[ eventIndex ] && ddo.event[ eventIndex ].video && ddo.event[ eventIndex ].video.id ? ddo.event[ eventIndex ].video.id : '' );
			s.linkTrackEvents = utilities.apl( 'event13', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'eVar168', s.linkTrackVars );
		}
	},

	'category_plp': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ) {}
	},
	'browse_results': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			mapMethods.setInitialLoadBrowseNucleus( ddo );

		}
	},

	'search_results': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {
			let searchTerm = ( ddo.page.onsiteSearchInfo.searchTerm ? ddo.page.onsiteSearchInfo.searchTerm : '' );

			s.events = utilities.apl( "event15" );

			s.prop4 = searchTerm;
			s.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults ? ddo.page.onsiteSearchInfo.numberOfResults : '' );
			s.prop21 = utilities.readCookieKeyValue( "s_sess", "s_pv_pName" );

			s.eVar5 = searchTerm;
			s.eVar12 = ( ddo.page.onsiteSearchInfo.resultsType ? ddo.page.onsiteSearchInfo.resultsType : '' );

		}
	},
	'pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			const pageNumber = ( ddo.page.displayAttributes && typeof ( ddo.page.displayAttributes.pageNumber ) !== 'undefined' ? ddo.page.displayAttributes.pageNumber : '');

			s.pageName = ddo.page.pageInfo.pageName + ">pagination";

			s.prop8 = ( ddo.page.onsiteSearchInfo.numberOfResults !== '0' ? ddo.page.onsiteSearchInfo.numberOfResults : 'zero' );

			s.prop16 = 'D=v29';

			s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.page );

			s.eVar29 = ( function ( pageobj ) {
				let result = "";

				if ( Array.isArray( pageobj.filter ) && pageobj.filter.length > 0 ) {
					let arrLength = pageobj.filter.length;

					for ( let index = 0; index < arrLength; index += 1 ) {
						result += pageobj.filter[ index ].position + "," + pageobj.filter[ index ].type + ":" + pageobj.filter[ index ].value;

						if ( pageobj.filter[ index ].selectionMethod ) {
							result += "," + pageobj.filter[ index ].selectionMethod;
						}

						if ( index < arrLength - 1 ) {
							result += "|";
						}
					}
				}

				return result;
			}( ddo.page ) );

			//For pagination case, give DDO the priority
			if ( ddo.page.onsiteSearchInfo.resultsCategory ) {

				s.eVar63 = ddo.page.onsiteSearchInfo.resultsCategory;

			}

			if ( ddo.content && Array.isArray( ddo.content.product ) && ddo.content.product.length ) {
				s.events = utilities.apl( "event119" );

				s.products = productString.productImpression( ddo.content.product, {
					"pageNumber": pageNumber
				} );

			}
		}

	},
	'cart_view': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

            s.events = utilities.apl( "scView,event169" );

			s.products = productString.cartView( ddo.cart.item, ddo, {
				"content": ddo.content,
				"addrevenueevents": true
			} );

		}
	},
	'empty_cart': {
		// Fire scView on empty cart
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function () {
			s.events = utilities.apl( "scView" );
		}
	},
	'product_view': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setProductView( ddo, eventIndex );
		}
	},

	'button_submission*order_submission': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'submit order',
		'setMetrics': function ( ddo ) {

			s.eVar26 = ( function ( ddo ) {
				var result = mapMethods.setEvar26( ddo );
				if ( ddo.user.profile.action === 'register' ) {
					s.events = utilities.apl( "event1,event25" );
					result = 'authenticated';
				}
				return result;
			}( ddo ) );

			if ( typeof ( ddo.cart.price.paymentMethod ) !== 'undefined' && Array.isArray( ddo.cart.price.paymentMethod ) && ddo.cart.price.paymentMethod.length ) {
				s.eVar33 = ddo.cart.price.paymentMethod.join( '|' );
			}
			else {
				s.eVar33 = ( ddo.cart.price.paymentMethod ? ddo.cart.price.paymentMethod : "" );
			}

			s.products = productString.opc( ddo.cart.item );

			s.transactionID = ( ddo.cart && ddo.cart.cartID ? ddo.cart.cartID : '' );

            s.linkTrackEvents = utilities.apl( "event1,event25", s.linkTrackEvents );
            s.linkTrackVars = utilities.apl( 'eVar26,eVar33,products,transactionID', s.linkTrackVars );
		}
	},
	'button_submission*cart_checkout': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'cart checkout',
		'setMetrics': function ( ddo ) {

			s.events = utilities.apl( "scCheckout" );

			s.products = productString.cartCheckout( ddo.cart.item );

            s.linkTrackEvents = utilities.apl( 'scCheckout', s.linkTrackEvents );
            s.linkTrackVars = utilities.apl( 'products', s.linkTrackVars );
		}
	},

	'button_submission*registration': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'account sign in',
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( "event1,event25" );

			s.eVar26 = mapMethods.setEvar26( ddo );

			s.linkTrackEvents = utilities.apl( 'event1,event25', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'eVar26', s.linkTrackVars );

		}
	},
	'button_submission*sign_in_success': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'sign in',
		'setMetrics': function ( ddo ) {
			s.events = utilities.apl( "event25" );

			s.eVar8 = ddo.page.pageInfo.pageType;
			s.eVar26 = mapMethods.setEvar26( ddo );

			s.linkTrackEvents = utilities.apl( 'event25', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'eVar8,eVar26', s.linkTrackVars );
		}
	},

	'interaction*pip_sub-content': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "sub-content interaction",
		'setMetrics': function ( ddo, eventIndex ) {
			s.events = utilities.apl( 'event3' );

			s.products = productString.skuOnly( ddo.product );

			s.eVar38 = ( function ( ddo, eventIndex ) {
				var subContent = ( ddo.event[ eventIndex ] && ddo.event[ eventIndex ].subContent ? ddo.event[ eventIndex ].subContent : "" ),
					result = "";

				if ( subContent ) { //<SECTION>|<COMPONENT>|<TARGET>(:POSITION)(:GUID)
					result = subContent.section + "|" + subContent.component + "|" + subContent.target + ( subContent.position && subContent.position !== 'n/a' ? ":" + subContent.position : "" ) + ( subContent.guid && subContent.guid !== 'n/a' ? ":" + subContent.guid : "" );
				}

				return result;
			}( ddo, eventIndex ) );

			s.linkTrackEvents = utilities.apl( 'event3', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'eVar38,products', s.linkTrackVars );
		}
	},

	'cart_view_modification*cart_add': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart update",
		'setMetrics': function ( ddo, eventIndex ) {

			s.events = utilities.apl( "scAdd,event2,event4" );

			s.events = utilities.apl( "event157" );

			var stashATCLoc = stash.getEventData( "cart add location" );

			s.products = productString.cartAdd( ddo.event[ eventIndex ].item, ddo, {
				"atcloc": stashATCLoc
			} );

			//clear stash after setting atc location
			stash.deleteEventData( "cart add location" );

            s.linkTrackEvents = utilities.apl( "scAdd,event2,event4,event157", s.linkTrackEvents );
            s.linkTrackVars = utilities.apl( 'products,prop37', s.linkTrackVars );
		}
	},
	'cart_view_modification*cart_remove': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': "cart remove",
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartRemove(ddo, eventIndex);

		}
	},

		'overlay': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			s.pageName = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			s.prop15 = ddo.page.pageInfo.pageName;
			s.prop17 = ddo.page.pageInfo.pageType;
			s.prop30 = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;

			s.prop35 = "D=pageName";

			s.eVar8 = ddo.event[ eventIndex ].eventInfo.eventName + " " + ddo.event[ eventIndex ].category.primaryCategory;
			s.eVar96 = s.prop15 ? s.prop15 : '';
			s.eVar97 = ddo.page.pageInfo.pageType;

			// prevent ITC tracking code related values from firing on Overlays
			s.eVar178 = '';
			s.eVar180 = '';
			s.events = utilities.listRemove(s.events, "event209");
			// End ITC prevent
		}
	},

	'search*filter_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change filter values',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFilterBy( ddo, eventIndex );
		}
	},
	'search*pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPagination( ddo, eventIndex );
		}
	},
	'browse*pagination': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setPagination( ddo, eventIndex );
		}
	},

	'browse*filter_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change filter values',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setFilterBy( ddo, eventIndex );
		}
	},
	'search*sort_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setSortBy( ddo, eventIndex );
		}
	},
	'browse*sort_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setSortBy( ddo, eventIndex );
		}
	},
	'search*view_type_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},
	'browse*view_type_by': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'change display attributes',
		'setMetrics': function ( ddo, eventIndex ) {
			s.eVar21 = mapMethods.setEvar21ForBrowseAndSearch( ddo.event[ eventIndex ] );
			mapMethods.setCommonTypeBy( ddo, eventIndex );
		}
	},

	'content_display*product_impression': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'product impression tracking',
		'setMetrics': function ( ddo ) {
			s.events = 'event119';

			s.prop30 = ddo.page && ddo.page.pageInfo && ddo.page.pageInfo.pageType ? ddo.page.pageInfo.pageType : '';

			let collectionID = ( ddo.content && ddo.content.collection && ddo.content.collection.collectionID ? ddo.content.collection.collectionID : '' )

			s.products = productString.productImpression( ddo.content.product, {
				"collectionID": collectionID,
				"pageNumber": mapMethods.getImpressionPageNumber( ddo.event[ 0 ], ddo.page ),
				"pageType": ddo.page.pageInfo.pageType,
			} );

            s.linkTrackEvents = utilities.apl( "event119", s.linkTrackEvents );
            s.linkTrackVars = utilities.apl( 'products,prop30,prop37', s.linkTrackVars );
		}
	},

	'error*error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error message',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setErrorMessage( ddo, eventIndex );
		}
	},
	'sys_msg*error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error message',
		'setMetrics': function ( ddo, eventIndex ) {
			mapMethods.setErrorMessage( ddo, eventIndex );
		}
	},
	'error*post_page_error': {
		'forcePageView': false,
		'reportingType': 'tl',
		'runUniversal': true,
		'trackLinkName': 'error',
		'setMetrics': function ( ddo, eventIndex ) {

			s.events = utilities.apl( 'event49' );

			s.list2 = ( function ( ddo, eventIndex ) {

				var list2 = "";

				if ( Array.isArray( ddo.event[ eventIndex ].eventInfo.error ) ) {

					var errors = ddo.event[ eventIndex ].eventInfo.error,
						result = [],
						_left = function ( str, count ) { // main purpose of this method is the safe checking
							str = typeof str !== 'undefined' ? str : '';
							count = typeof count !== 'undefined' ? count : 2;

							return str.substr( 0, count );
						};

					for ( var error in errors ) {

						if ( errors.hasOwnProperty( error ) ) {

							result.push( _left( errors[ error ].type ) + ":" + _left( errors[ error ].displayType ) + ":" + ( errors[ error ].pageSection ? errors[ error ].pageSection : '' ) + ":" + ( errors[ error ].message ? errors[ error ].message : '' ) + ":" + ( errors[ error ].code ? errors[ error ].code : '' ) );

						}
					}

					list2 = result.join( "|" );
				}

				return list2;

			}( ddo, eventIndex ) );

			if ( ddo.page.pageInfo.pageType === "product configuration" && ( Array.isArray( ddo.product ) && ddo.product.length && ddo.product[ 0 ].productInfo && ddo.product[ 0 ].productInfo.sku ) ) {
				s.products = productString.skuOnly( ddo.product );
			}

			s.linkTrackEvents = utilities.apl( 'event49', s.linkTrackEvents );
			s.linkTrackVars = utilities.apl( 'list2,events,products', s.linkTrackVars );
		}
	},

	'stash*cart_add_location': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var eventObj = ddo.event[ eventIndex ],
				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash );

			// will be picked up by cart add event handler
			stash.addToEventData( eventObj.eventInfo.eventName, data );
		}
	},

	'stash*type_ahead': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash;

			// will be picked up by search page event handler
			stash.addToWillPersist( "searchMedium", stashData.searchMedium ); // searchMedium is to be used at a future date, but could be utilized to determine evar 12
			stash.addToWillPersist( "searchTerm", stashData.searchTerm );
			stash.addToWillPersist( "searchTermOrigin", stashData.searchTermOrigin );
			stash.addToWillPersist( "searchTermSuggestion", stashData.searchTermSuggestion );
			stash.addToWillPersist( "searchTypeAheadBits", stashData.searchTypeAheadBits );
			stash.addToWillPersist( "searchTypeAheadType", stashData.searchTypeAheadType );
			stash.addToWillPersist( "searchTypeAheadImp", stashData.searchTypeAheadImp );
		}
	},
	'stash*related_term': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {
			var stashData = ddo.event[ eventIndex ].stash;

			// will be picked up by search page event handler
			stash.addToWillPersist( "searchTerm", stashData.searchTerm );
			stash.addToWillPersist( "searchMedium", stashData.searchMedium );
		}
	},

	'stash*cart_addition_info': {
		'forcePageView': false,
		'reportingType': 'non-reporting',
		'runUniversal': false,
		'setMetrics': function ( ddo, eventIndex ) {

			var eventObj = ddo.event[ eventIndex ],

				data = digitalDataFormatters.formatATCLocation( ddo, eventObj.stash );

			// will be picked up by cart add event handler
			stash.addToEventData( "recCartAddLoc", data );

			stash.addToEventData( "recommendationCartAdd", eventObj.stash.item );
		}
	},

	'purchase': {
		'forcePageView': false,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo ) {

			s.eVar33 = ( ddo.transaction.price.paymentMethod ? ddo.transaction.price.paymentMethod : '' );
			s.eVar34 = ( ddo.transaction && ddo.transaction.transactionID ? ddo.transaction.transactionID : "" );
			s.eVar55 = ( ddo.referral && ddo.referral.type ? ddo.referral.type : '' );

			s.purchaseID = ( function ( ddo ) {
				let purchaseID = "",
					purchIdSource = "";

				if ( ddo.transaction && ddo.transaction.transactionID ) {
					purchaseID = ddo.transaction.transactionID;
					purchIdSource = "ddo purchase id";
				} else {
					purchIdSource = "queryParam	purchase id";
					purchaseID = s.Util.getQueryParam( 'orderId', document.URL );
				}

				// track source of purchase id (dev use)
				s.prop37 = utilities.apl( purchIdSource, s.prop37 );

				return purchaseID;

			}( ddo ) );

			s.transactionID = ( typeof ( s.purchaseID ) === 'string' ? s.purchaseID.toLowerCase() : "" );

			s.state = ddo.transaction.profile.address.stateProvince;
			s.zip = ddo.transaction.profile.address.postalCode;

			s.events = utilities.apl( "purchase,event5=" + digitalDataFormatters.stripComma( ddo.transaction.price.tax ) + ",event6=" + ( ddo.transaction.price.shipping ? digitalDataFormatters.stripComma( ddo.transaction.price.shipping ) : '' ) );

			s.events = utilities.apl( "event57,event178,event181=" + ( ddo.transaction.price.transactionTotal ? digitalDataFormatters.stripComma( ddo.transaction.price.transactionTotal ) : '' ) );

			s.products = productString.purchase( ddo.transaction.item );

		}
	},

	'add_to_cart_click*cart_add': {
		'forcePageView': true,
		'reportingType': 't',
		'runUniversal': true,
		'setMetrics': function ( ddo, eventIndex ) {

			mapMethods.setCartAdd( ddo, eventIndex );

		}
	},

};


nodes[ 'button_submission*flex_button' ] = {
	'forcePageView': false,
	'reportingType': 'tl',
	'runUniversal': true,
	'trackLinkName': "flexButton",
	'setMetrics': function ( ddo, eventIndex ) {
		var eventObj = ddo.event[ eventIndex ];

		s.prop60 = ( eventObj && eventObj.eventInfo && eventObj.eventInfo.eventDescription ? eventObj.eventInfo.eventDescription : '' );
		s.linkTrackVars = utilities.apl( 'prop60', s.linkTrackVars );
	}
};

nodes[ 'button_submission*cart_add' ] = {
	'forcePageView': true,
	'reportingType': 't',
	'runUniversal': true,
	'setMetrics': function ( ddo, eventIndex ) {

		mapMethods.setCartAdd( ddo, eventIndex );

		// add gcc specific event
		s.events = utilities.apl( 'event157' );

		s.pageName = "cart add";
		s.prop30 = "cart add";
		s.eVar8 = "cart add";
	}
};


export {
	nodes
};
